<template>
	<div>
		<h2>{{ title }}</h2>
		<div class="section">
			<slot></slot>
			<FormField
				v-for="field in orderedFields"
				:key="field.name"
				:class="{ fullwidth: field.fullWidth }"
    			:field="field"
			/>
		</div>
	</div>
</template>

<script>
import FormField from  "./FormField";

export default {
	components: {
		FormField,
	 },
	props: {
		title: String,
		fields: Array,
	},
	computed: {
		orderedFields() {
			const unsortedFields = [...this.fields]
			return unsortedFields.sort((a, b) => !a.fullWidth === !b.fullWidth ? 0 : !!a.fullWidth - !!b.fullWidth)
		}
	}
}
</script>

<style lang="scss">
@import "@/styles/form.scss";

.section {
	display: flex;
	flex-wrap: wrap;
	margin-right: -$form-field-margin;

	.form__field {
		margin-bottom: 20px;
		flex-basis: calc(50% - #{$form-field-margin});
		margin-right: $form-field-margin;
	}

	.form__field.fullwidth {
		flex-basis: 100%;
	}
}

@media only screen and (max-width: $tablet-breakpoint) {
	.section {
		.form__field {
			flex-basis: 100%;
		}
	}
}

</style>
